// extracted by mini-css-extract-plugin
export var embed_responsive = "video-module--embed_responsive--28339";
export var embed_responsive_16by9 = "video-module--embed_responsive_16by9--c8ca3";
export var embed_responsive_item = "video-module--embed_responsive_item--5328f";
export var videoBlock = "video-module--videoBlock--9d3c3";
export var videoBlock__timestamps = "video-module--videoBlock__timestamps--31365";